import { H4 } from 'UIComponents/elements/headings';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import ApprovalButtons from '../consumer/ApprovalButtons';
import { ApprovalEmptyStateI18nFirstSection, ApprovalEmptyStateI18nSecondSection, ApprovalEmptyStateI18nTitle } from '../i18n/ApprovalEmptyStateI18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function ApprovalEmptyState() {
  return /*#__PURE__*/_jsx("div", {
    className: "p-all-5",
    "data-test-id": "product-approvals-approval-sidebar-empty-state",
    children: /*#__PURE__*/_jsxs(UIErrorMessage, {
      type: "notFound",
      illustration: "approvals",
      illustrationProps: {
        width: 150
      },
      title: /*#__PURE__*/_jsx(H4, {
        children: /*#__PURE__*/_jsx(ApprovalEmptyStateI18nTitle, {})
      }),
      children: [/*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(ApprovalEmptyStateI18nFirstSection, {})
      }), /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(ApprovalEmptyStateI18nSecondSection, {})
      }), /*#__PURE__*/_jsx(ApprovalButtons, {
        children: /*#__PURE__*/_jsx(_Fragment, {})
      })]
    })
  });
}
export default ApprovalEmptyState;